import qs from 'qs';
import axios from '../../../utils/customAxiosUtil';

// import { ReponseControlGpHistory } from '../models/controlGpModel';

export const analysisSimulator = {
  //비행 현황 목록
  list: async (data: string, page: number) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });

    return await axios.get(`/api/anls/smlt/list${queryString}&page=${page}`);
  },
  // 비행 이력 데이터 조회
  logList: async (id: string) => {
    return await axios.get(`/api/anls/smlt/hist/${id}`);
  },

  //비행 상세 데이터 조회
  detail: async (id: string) => {
    return await axios.get(`/api/anls/smlt/detail/${id}`);
  },

  //비행 통계 데이터 조회
  stcsList: async (id: string) => {
    return await axios.get(`/api/anls/smlt/stcs/${id}`);
  }
};
